import {
  useGetItemPublic,
  useGetListItems,
  useMutateItem,
  useMutateItemWithFileUpload,
} from '../../../hooks/entityMethodsHook'
import { useUploadValueList } from '../../valueLists/hooks'

export const useGetItems = (queryKey: string, id: string | undefined) => {
  const uri = `daily-reports?projectId=${id}`
  return useGetListItems(queryKey, uri)
}

export const useGetItem = (queryKey: string, id: string | undefined) => {
  const uri = `daily-reports/${id}?populate=project`
  //return useGetItemById(queryKey, uri, id)
  return useGetItemPublic(queryKey, uri, !!id)
}

export const useMutateCreateDailyReport = (key: string) => {
  const uri = `daily-reports`
  return useMutateItem(key, uri, '', 'projectReportFormData')
}

export const useUploadDailyReports = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/daily-reports/upload`
  return useUploadValueList(queryKey, uri)
}

export const useGetReportNumberExists = (key: string, reportNumber: string) => {
  const uri = `daily-reports/report-number-exists?reportNumber=${reportNumber}`
  return useGetListItems(key, uri, {}, !!reportNumber)
}
